'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
require('./DPlayer.scss');
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _options = require('./options');
var _options2 = _interopRequireDefault(_options);
var _i18n = require('./i18n');
var _i18n2 = _interopRequireDefault(_i18n);
var _html = require('./html');
var _html2 = _interopRequireDefault(_html);
var _svg = require('./svg');
var _svg2 = _interopRequireDefault(_svg);
var _danmaku = require('./danmaku');
var _danmaku2 = _interopRequireDefault(_danmaku);
var _thumbnails = require('./thumbnails');
var _thumbnails2 = _interopRequireDefault(_thumbnails);
var _events = require('./events');
var _events2 = _interopRequireDefault(_events);
var _fullscreen = require('./fullscreen');
var _fullscreen2 = _interopRequireDefault(_fullscreen);
var _user = require('./user');
var _user2 = _interopRequireDefault(_user);
var _subtitle = require('./subtitle');
var _subtitle2 = _interopRequireDefault(_subtitle);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var index = 0;
var instances = [];
var DPlayer = function () {
    function DPlayer(options) {
        var _this = this;
        _classCallCheck(this, DPlayer);
        this.options = (0, _options2.default)(options);
        this.options.container.classList.add('dplayer');
        if (this.options.video.quality) {
            this.qualityIndex = this.options.video.defaultQuality;
            this.quality = this.options.video.quality[this.options.video.defaultQuality];
        }
        this.tran = new _i18n2.default(this.options.lang).tran;
        this.icons = new _svg2.default(this.options);
        this.events = new _events2.default();
        this.user = new _user2.default(this);
        this.container = this.options.container;
        if (!this.options.danmaku) {
            this.container.classList.add('dplayer-no-danmaku');
        }
        if (_utils.isMobile) {
            this.container.classList.add('dplayer-mobile');
        }
        this.container.innerHTML = _html2.default.main(this.options, index, this.tran, this.icons);
        var bar = {};
        bar.volumeBar = this.container.getElementsByClassName('dplayer-volume-bar-inner')[0];
        bar.playedBar = this.container.getElementsByClassName('dplayer-played')[0];
        bar.loadedBar = this.container.getElementsByClassName('dplayer-loaded')[0];
        var pbar = this.container.getElementsByClassName('dplayer-bar-wrap')[0];
        var pbarTimeTips = this.container.getElementsByClassName('dplayer-bar-time')[0];
        var barWidth = void 0;
        this.updateBar = function (type, percentage, direction) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            bar[type + 'Bar'].style[direction] = percentage * 100 + '%';
        };
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.container.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        if (this.options.danmaku) {
            this.danmaku = new _danmaku2.default({
                container: this.container.getElementsByClassName('dplayer-danmaku')[0],
                opacity: this.user.get('opacity'),
                callback: function callback() {
                    _this.container.getElementsByClassName('dplayer-danloading')[0].style.display = 'none';
                    if (_this.options.autoplay && !_utils.isMobile) {
                        _this.play();
                    } else if (_utils.isMobile) {
                        _this.pause();
                    }
                },
                error: function error(msg) {
                    _this.notice(msg);
                },
                apiBackend: this.options.apiBackend,
                borderColor: this.options.theme,
                height: this.arrow ? 24 : 30,
                time: function time() {
                    return _this.video.currentTime;
                },
                unlimited: this.user.get('unlimited'),
                api: {
                    id: this.options.danmaku.id,
                    address: this.options.danmaku.api,
                    token: this.options.danmaku.token,
                    maximum: this.options.danmaku.maximum,
                    addition: this.options.danmaku.addition,
                    user: this.options.danmaku.user
                },
                events: this.events
            });
        }
        this.arrow = this.container.offsetWidth <= 500;
        if (this.arrow) {
            var arrowStyle = document.createElement('style');
            arrowStyle.innerHTML = '.dplayer .dplayer-danmaku{font-size:18px}';
            document.head.appendChild(arrowStyle);
        }
        this.video = this.container.getElementsByClassName('dplayer-video-current')[0];
        this.bezel = this.container.getElementsByClassName('dplayer-bezel-icon')[0];
        this.bezel.addEventListener('animationend', function () {
            _this.bezel.classList.remove('dplayer-bezel-transition');
        });
        this.playButton = this.container.getElementsByClassName('dplayer-play-icon')[0];
        this.paused = true;
        this.playButton.addEventListener('click', function () {
            _this.toggle();
        });
        var videoWrap = this.container.getElementsByClassName('dplayer-video-wrap')[0];
        var conMask = this.container.getElementsByClassName('dplayer-controller-mask')[0];
        if (!_utils.isMobile) {
            videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            conMask.addEventListener('click', function () {
                _this.toggle();
            });
        } else {
            var toggleController = function toggleController() {
                if (_this.container.classList.contains('dplayer-hide-controller')) {
                    _this.container.classList.remove('dplayer-hide-controller');
                } else {
                    _this.container.classList.add('dplayer-hide-controller');
                }
            };
            videoWrap.addEventListener('click', toggleController);
            conMask.addEventListener('click', toggleController);
        }
        var lastPlayPos = 0;
        var currentPlayPos = 0;
        var bufferingDetected = false;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        var setCheckLoadingTime = function setCheckLoadingTime() {
            _this.checkLoading = setInterval(function () {
                currentPlayPos = _this.video.currentTime;
                if (!bufferingDetected && currentPlayPos === lastPlayPos && !_this.video.paused) {
                    _this.container.classList.add('dplayer-loading');
                    bufferingDetected = true;
                }
                if (bufferingDetected && currentPlayPos > lastPlayPos && !_this.video.paused) {
                    _this.container.classList.remove('dplayer-loading');
                    bufferingDetected = false;
                }
                lastPlayPos = currentPlayPos;
            }, 100);
        };
        var clearCheckLoadingTime = function clearCheckLoadingTime() {
            clearInterval(_this.checkLoading);
        };
        this.playedTime = false;
        this.animationFrame = function () {
            if (_this.playedTime) {
                _this.updateBar('played', _this.video.currentTime / _this.video.duration, 'width');
                _this.container.getElementsByClassName('dplayer-ptime')[0].innerHTML = _utils2.default.secondToTime(_this.video.currentTime);
            }
            window.requestAnimationFrame(_this.animationFrame);
        };
        window.requestAnimationFrame(this.animationFrame);
        this.setTime = function (type) {
            if (!type) {
                _this.playedTime = true;
                setCheckLoadingTime();
            } else {
                _this[type + 'Time'] = true;
                if (type === 'played') {
                    setCheckLoadingTime();
                }
            }
        };
        this.clearTime = function (type) {
            if (!type) {
                _this.playedTime = false;
                clearCheckLoadingTime();
            } else {
                _this[type + 'Time'] = false;
                if (type === 'played') {
                    clearCheckLoadingTime();
                }
            }
        };
        if (this.options.video.thumbnails) {
            this.initThumbnails();
        }
        this.isTimeTipsShow = true;
        this.mouseHandler = this.mouseHandler(pbar, pbarTimeTips).bind(this);
        pbar.addEventListener('mousemove', this.mouseHandler);
        pbar.addEventListener('mouseenter', this.mouseHandler);
        pbar.addEventListener('mouseleave', this.mouseHandler);
        var thumbMove = function thumbMove(e) {
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.container.getElementsByClassName('dplayer-ptime')[0].innerHTML = _utils2.default.secondToTime(percentage * _this.video.duration);
        };
        var thumbUp = function thumbUp(e) {
            document.removeEventListener('mouseup', thumbUp);
            document.removeEventListener('mousemove', thumbMove);
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
            _this.setTime();
        };
        pbar.addEventListener('mousedown', function () {
            barWidth = pbar.clientWidth;
            _this.clearTime();
            document.addEventListener('mousemove', thumbMove);
            document.addEventListener('mouseup', thumbUp);
        });
        var volumeEle = this.container.getElementsByClassName('dplayer-volume')[0];
        var volumeBarWrapWrap = this.container.getElementsByClassName('dplayer-volume-bar-wrap')[0];
        var volumeBarWrap = this.container.getElementsByClassName('dplayer-volume-bar')[0];
        var volumeicon = this.container.getElementsByClassName('dplayer-volume-icon')[0].getElementsByClassName('dplayer-icon-content')[0];
        var vWidth = 35;
        this.switchVolumeIcon = function () {
            if (_this.volume() >= 0.95) {
                volumeicon.innerHTML = _this.icons.get('volume-up');
            } else if (_this.volume() > 0) {
                volumeicon.innerHTML = _this.icons.get('volume-down');
            } else {
                volumeicon.innerHTML = _this.icons.get('volume-off');
            }
        };
        var volumeMove = function volumeMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        };
        var volumeUp = function volumeUp() {
            document.removeEventListener('mouseup', volumeUp);
            document.removeEventListener('mousemove', volumeMove);
            volumeEle.classList.remove('dplayer-volume-active');
        };
        volumeBarWrapWrap.addEventListener('click', function (event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        });
        volumeBarWrapWrap.addEventListener('mousedown', function () {
            document.addEventListener('mousemove', volumeMove);
            document.addEventListener('mouseup', volumeUp);
            volumeEle.classList.add('dplayer-volume-active');
        });
        volumeicon.addEventListener('click', function () {
            if (_this.video.muted) {
                _this.video.muted = false;
                _this.switchVolumeIcon();
                _this.updateBar('volume', _this.volume(), 'width');
            } else {
                _this.video.muted = true;
                volumeicon.innerHTML = _this.icons.get('volume-off');
                _this.updateBar('volume', 0, 'width');
            }
        });
        this.hideTime = 0;
        var hideController = function hideController() {
            _this.container.classList.remove('dplayer-hide-controller');
            clearTimeout(_this.hideTime);
            _this.hideTime = setTimeout(function () {
                if (_this.video.played.length && !_this.disableHideController) {
                    _this.container.classList.add('dplayer-hide-controller');
                    closeSetting();
                    closeComment();
                }
            }, 2000);
        };
        if (!_utils.isMobile) {
            this.container.addEventListener('mousemove', hideController);
            this.container.addEventListener('click', hideController);
        }
        var settingHTML = _html2.default.setting(this.tran, this.icons);
        var settingIcon = this.container.getElementsByClassName('dplayer-setting-icon')[0];
        var settingBox = this.container.getElementsByClassName('dplayer-setting-box')[0];
        var mask = this.container.getElementsByClassName('dplayer-mask')[0];
        settingBox.innerHTML = settingHTML.original;
        var closeSetting = function closeSetting() {
            if (settingBox.classList.contains('dplayer-setting-box-open')) {
                settingBox.classList.remove('dplayer-setting-box-open');
                mask.classList.remove('dplayer-mask-show');
                setTimeout(function () {
                    settingBox.classList.remove('dplayer-setting-box-narrow');
                    settingBox.innerHTML = settingHTML.original;
                    settingEvent();
                }, 300);
            }
            _this.disableHideController = false;
        };
        var openSetting = function openSetting() {
            _this.disableHideController = true;
            settingBox.classList.add('dplayer-setting-box-open');
            mask.classList.add('dplayer-mask-show');
        };
        mask.addEventListener('click', function () {
            closeSetting();
        });
        settingIcon.addEventListener('click', function () {
            openSetting();
        });
        this.loop = this.options.loop;
        var showdan = this.user.get('danmaku');
        if (!showdan) {
            this.danmaku && this.danmaku.hide();
        }
        var unlimitDan = this.user.get('unlimited');
        var settingEvent = function settingEvent() {
            var loopEle = _this.container.getElementsByClassName('dplayer-setting-loop')[0];
            var loopToggle = loopEle.getElementsByClassName('dplayer-toggle-setting-input')[0];
            loopToggle.checked = _this.loop;
            loopEle.addEventListener('click', function () {
                loopToggle.checked = !loopToggle.checked;
                if (loopToggle.checked) {
                    _this.loop = true;
                } else {
                    _this.loop = false;
                }
                closeSetting();
            });
            var showDanEle = _this.container.getElementsByClassName('dplayer-setting-showdan')[0];
            var showDanToggle = showDanEle.getElementsByClassName('dplayer-showdan-setting-input')[0];
            showDanToggle.checked = showdan;
            showDanEle.addEventListener('click', function () {
                showDanToggle.checked = !showDanToggle.checked;
                if (showDanToggle.checked) {
                    showdan = true;
                    if (!_this.paused) {
                        _this.danmaku.show();
                    }
                } else {
                    showdan = false;
                    _this.danmaku.hide();
                }
                _this.user.set('danmaku', showdan ? 1 : 0);
                closeSetting();
            });
            var unlimitDanEle = _this.container.getElementsByClassName('dplayer-setting-danunlimit')[0];
            var unlimitDanToggle = unlimitDanEle.getElementsByClassName('dplayer-danunlimit-setting-input')[0];
            unlimitDanToggle.checked = unlimitDan;
            unlimitDanEle.addEventListener('click', function () {
                unlimitDanToggle.checked = !unlimitDanToggle.checked;
                if (unlimitDanToggle.checked) {
                    unlimitDan = true;
                    _this.danmaku.unlimit(true);
                } else {
                    unlimitDan = false;
                    _this.danmaku.unlimit(false);
                }
                _this.user.set('unlimited', unlimitDan ? 1 : 0);
                closeSetting();
            });
            var speedEle = _this.container.getElementsByClassName('dplayer-setting-speed')[0];
            speedEle.addEventListener('click', function () {
                settingBox.classList.add('dplayer-setting-box-narrow');
                settingBox.innerHTML = settingHTML.speed;
                var speedItem = settingBox.getElementsByClassName('dplayer-setting-speed-item');
                var _loop = function _loop(i) {
                    speedItem[i].addEventListener('click', function () {
                        _this.video.playbackRate = speedItem[i].dataset.speed;
                        closeSetting();
                    });
                };
                for (var i = 0; i < speedItem.length; i++) {
                    _loop(i);
                }
            });
            if (_this.danmaku) {
                bar.danmakuBar = _this.container.getElementsByClassName('dplayer-danmaku-bar-inner')[0];
                var danmakuBarWrapWrap = _this.container.getElementsByClassName('dplayer-danmaku-bar-wrap')[0];
                var danmakuBarWrap = _this.container.getElementsByClassName('dplayer-danmaku-bar')[0];
                var danmakuSettingBox = _this.container.getElementsByClassName('dplayer-setting-danmaku')[0];
                var dWidth = 130;
                _this.on('danmaku_opacity', function (percentage) {
                    _this.updateBar('danmaku', percentage, 'width');
                    _this.user.set('opacity', percentage);
                });
                _this.danmaku.opacity(_this.user.get('opacity'));
                var danmakuMove = function danmakuMove(event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.danmaku.opacity(percentage);
                };
                var danmakuUp = function danmakuUp() {
                    document.removeEventListener('mouseup', danmakuUp);
                    document.removeEventListener('mousemove', danmakuMove);
                    danmakuSettingBox.classList.remove('dplayer-setting-danmaku-active');
                };
                danmakuBarWrapWrap.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.danmaku.opacity(percentage);
                });
                danmakuBarWrapWrap.addEventListener('mousedown', function () {
                    document.addEventListener('mousemove', danmakuMove);
                    document.addEventListener('mouseup', danmakuUp);
                    danmakuSettingBox.classList.add('dplayer-setting-danmaku-active');
                });
            }
        };
        settingEvent();
        if (this.video.duration !== 1) {
            this.container.getElementsByClassName('dplayer-dtime')[0].innerHTML = this.video.duration ? _utils2.default.secondToTime(this.video.duration) : '00:00';
        }
        if (!this.danmaku) {
            if (this.options.autoplay && !_utils.isMobile) {
                this.play();
            } else if (_utils.isMobile) {
                this.pause();
            }
        }
        var controller = this.container.getElementsByClassName('dplayer-controller')[0];
        var commentInput = this.container.getElementsByClassName('dplayer-comment-input')[0];
        var commentIcon = this.container.getElementsByClassName('dplayer-comment-icon')[0];
        var commentSettingIcon = this.container.getElementsByClassName('dplayer-comment-setting-icon')[0];
        var commentSettingBox = this.container.getElementsByClassName('dplayer-comment-setting-box')[0];
        var commentSendIcon = this.container.getElementsByClassName('dplayer-send-icon')[0];
        var closeCommentSetting = function closeCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            }
        };
        var toggleCommentSetting = function toggleCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            } else {
                commentSettingBox.classList.add('dplayer-comment-setting-open');
            }
        };
        var closeComment = function closeComment() {
            if (!controller.classList.contains('dplayer-controller-comment')) {
                return;
            }
            controller.classList.remove('dplayer-controller-comment');
            mask.classList.remove('dplayer-mask-show');
            _this.container.classList.remove('dplayer-show-controller');
            closeCommentSetting();
            _this.disableHideController = false;
        };
        var openComment = function openComment() {
            _this.disableHideController = true;
            if (!controller.classList.contains('dplayer-controller-comment')) {
                controller.classList.add('dplayer-controller-comment');
                mask.classList.add('dplayer-mask-show');
                _this.container.classList.add('dplayer-show-controller');
                commentInput.focus();
            }
        };
        mask.addEventListener('click', function () {
            closeComment();
        });
        commentIcon.addEventListener('click', function () {
            openComment();
        });
        commentSettingIcon.addEventListener('click', function () {
            toggleCommentSetting();
        });
        var colorSetting = this.container.getElementsByClassName('dplayer-comment-setting-color')[0];
        colorSetting.addEventListener('click', function () {
            var sele = colorSetting.querySelector('input:checked+span');
            if (sele) {
                var color = colorSetting.querySelector('input:checked').value;
                commentSettingIcon.getElementsByClassName('dplayer-fill')[0].style.fill = color;
                commentInput.style.color = color;
                commentSendIcon.getElementsByClassName('dplayer-fill')[0].style.fill = color;
            }
        });
        var sendComment = function sendComment() {
            commentInput.blur();
            if (!commentInput.value.replace(/^\s+|\s+$/g, '')) {
                _this.notice(_this.tran('Please input danmaku content!'));
                return;
            }
            _this.danmaku.send({
                text: commentInput.value,
                color: _this.container.querySelector('.dplayer-comment-setting-color input:checked').value,
                type: _this.container.querySelector('.dplayer-comment-setting-type input:checked').value
            }, function () {
                commentInput.value = '';
                closeComment();
            });
        };
        commentInput.addEventListener('click', function () {
            closeCommentSetting();
        });
        commentInput.addEventListener('keydown', function (e) {
            var event = e || window.event;
            if (event.keyCode === 13) {
                sendComment();
            }
        });
        commentSendIcon.addEventListener('click', sendComment);
        this.fullScreen = new _fullscreen2.default(this);
        this.container.getElementsByClassName('dplayer-full-icon')[0].addEventListener('click', function () {
            _this.fullScreen.toggle('browser');
        });
        this.container.getElementsByClassName('dplayer-full-in-icon')[0].addEventListener('click', function () {
            _this.fullScreen.toggle('web');
        });
        var handleKeyDown = function handleKeyDown(e) {
            if (_this.focus) {
                var tag = document.activeElement.tagName.toUpperCase();
                var editable = document.activeElement.getAttribute('contenteditable');
                if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                    var event = e || window.event;
                    var percentage = void 0;
                    switch (event.keyCode) {
                    case 32:
                        event.preventDefault();
                        _this.toggle();
                        break;
                    case 37:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime - 5);
                        hideController();
                        break;
                    case 39:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime + 5);
                        hideController();
                        break;
                    case 38:
                        event.preventDefault();
                        percentage = _this.volume() + 0.1;
                        _this.volume(percentage);
                        break;
                    case 40:
                        event.preventDefault();
                        percentage = _this.volume() - 0.1;
                        _this.volume(percentage);
                        break;
                    }
                }
            }
        };
        if (this.options.hotkey) {
            document.addEventListener('keydown', handleKeyDown);
        }
        document.addEventListener('keydown', function (e) {
            var event = e || window.event;
            switch (event.keyCode) {
            case 27:
                if (_this.fullScreen.isFullScreen('web')) {
                    _this.fullScreen.cancel('web');
                }
                break;
            }
        });
        var menu = this.container.getElementsByClassName('dplayer-menu')[0];
        this.container.addEventListener('contextmenu', function (e) {
            var event = e || window.event;
            event.preventDefault();
            menu.classList.add('dplayer-menu-show');
            var clientRect = _this.container.getBoundingClientRect();
            var menuLeft = event.clientX - clientRect.left;
            var menuTop = event.clientY - clientRect.top;
            if (menuLeft + menu.offsetWidth >= clientRect.width) {
                menu.style.right = clientRect.width - menuLeft + 'px';
                menu.style.left = 'initial';
            } else {
                menu.style.left = event.clientX - _this.container.getBoundingClientRect().left + 'px';
                menu.style.right = 'initial';
            }
            if (menuTop + menu.offsetHeight >= clientRect.height) {
                menu.style.bottom = clientRect.height - menuTop + 'px';
                menu.style.top = 'initial';
            } else {
                menu.style.top = event.clientY - _this.container.getBoundingClientRect().top + 'px';
                menu.style.bottom = 'initial';
            }
            mask.classList.add('dplayer-mask-show');
            _this.events.trigger('contextmenu_show');
            mask.addEventListener('click', function () {
                mask.classList.remove('dplayer-mask-show');
                menu.classList.remove('dplayer-menu-show');
                _this.events.trigger('contextmenu_hide');
            });
        });
        if (this.options.video.quality) {
            this.container.getElementsByClassName('dplayer-quality-list')[0].addEventListener('click', function (e) {
                if (e.target.classList.contains('dplayer-quality-item')) {
                    _this.switchQuality(e.target.dataset.index);
                }
            });
        }
        if (this.options.screenshot) {
            var camareIcon = this.container.getElementsByClassName('dplayer-camera-icon')[0];
            camareIcon.addEventListener('click', function () {
                var canvas = document.createElement('canvas');
                canvas.width = _this.video.videoWidth;
                canvas.height = _this.video.videoHeight;
                canvas.getContext('2d').drawImage(_this.video, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL();
                camareIcon.href = dataURL;
                camareIcon.download = 'DPlayer.png';
                _this.events.trigger('screenshot', dataURL);
            });
        }
        if (this.options.subtitle) {
            var subtitleIcon = this.container.getElementsByClassName('dplayer-subtitle-icon')[0];
            var subtitleIn = subtitleIcon.getElementsByClassName('dplayer-icon-content')[0];
            this.events.on('subtitle_show', function () {
                subtitleIcon.dataset.balloon = _this.tran('Hide subtitle');
                subtitleIn.style.opacity = '';
                _this.user.set('subtitle', 1);
            });
            this.events.on('subtitle_hide', function () {
                subtitleIcon.dataset.balloon = _this.tran('Show subtitle');
                subtitleIn.style.opacity = '0.4';
                _this.user.set('subtitle', 0);
            });
            subtitleIcon.addEventListener('click', function () {
                _this.subtitle.toggle();
            });
        }
        this.initVideo(this.video, this.quality && this.quality.type || this.options.video.type);
        index++;
        instances.push(this);
    }
    _createClass(DPlayer, [
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.video.duration) {
                    time = Math.min(time, this.video.duration);
                }
                if (this.video.currentTime < time) {
                    this.notice(this.tran('FF') + ' ' + (time - this.video.currentTime).toFixed(0) + ' ' + this.tran('s'));
                } else if (this.video.currentTime > time) {
                    this.notice(this.tran('REW') + ' ' + (this.video.currentTime - time).toFixed(0) + ' ' + this.tran('s'));
                }
                this.video.currentTime = time;
                if (this.danmaku) {
                    this.danmaku.seek();
                }
                this.updateBar('played', time / this.video.duration, 'width');
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
                if (this.video.paused) {
                    this.bezel.innerHTML = this.icons.get('play');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.playButton.innerHTML = this.icons.get('pause');
                this.video.play();
                this.setTime();
                this.container.classList.add('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.play();
                }
                if (this.options.mutex) {
                    for (var i = 0; i < instances.length; i++) {
                        if (this !== instances[i]) {
                            instances[i].pause();
                        }
                    }
                }
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
                this.container.classList.remove('dplayer-loading');
                if (!this.video.paused) {
                    this.bezel.innerHTML = this.icons.get('pause');
                    this.bezel.classList.add('dplayer-bezel-transition');
                }
                this.ended = false;
                this.playButton.innerHTML = this.icons.get('play');
                this.video.pause();
                this.clearTime();
                this.container.classList.remove('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.pause();
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nostorage, nonotice) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    this.updateBar('volume', percentage, 'width');
                    var formatPercentage = (percentage * 100).toFixed(0) + '%';
                    this.container.getElementsByClassName('dplayer-volume-bar-wrap')[0].dataset.balloon = formatPercentage;
                    if (!nostorage) {
                        this.user.set('volume', percentage);
                    }
                    if (!nonotice) {
                        this.notice(this.tran('Volume') + ' ' + (percentage * 100).toFixed(0) + '%');
                    }
                    this.video.volume = percentage;
                    if (this.video.muted) {
                        this.video.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.video.volume;
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(video, danmakuAPI) {
                this.pause();
                this.video.poster = video.pic ? video.pic : '';
                this.video.src = video.url;
                this.initMSE(this.video, video.type || 'auto');
                if (danmakuAPI) {
                    this.container.getElementsByClassName('dplayer-danloading')[0].style.display = 'block';
                    this.updateBar('played', 0, 'width');
                    this.updateBar('loaded', 0, 'width');
                    this.container.getElementsByClassName('dplayer-ptime')[0].innerHTML = '00:00';
                    this.container.getElementsByClassName('dplayer-danmaku')[0].innerHTML = '';
                    if (this.danmaku) {
                        this.danmaku.reload({
                            id: danmakuAPI.id,
                            address: danmakuAPI.api,
                            token: danmakuAPI.token,
                            maximum: danmakuAPI.maximum,
                            addition: danmakuAPI.addition,
                            user: danmakuAPI.user
                        });
                    }
                }
            }
        },
        {
            key: 'initMSE',
            value: function initMSE(video, type) {
                this.type = type;
                if (this.type === 'auto') {
                    if (/m3u8(#|\?|$)/i.exec(video.src)) {
                        this.type = 'hls';
                    } else if (/.flv(#|\?|$)/i.exec(video.src)) {
                        this.type = 'flv';
                    } else if (/.mpd(#|\?|$)/i.exec(video.src)) {
                        this.type = 'dash';
                    } else {
                        this.type = 'normal';
                    }
                }
                if (this.type === 'hls' && Hls && Hls.isSupported()) {
                    var hls = new Hls();
                    hls.loadSource(video.src);
                    hls.attachMedia(video);
                }
                if (this.type === 'flv' && flvjs && flvjs.isSupported()) {
                    var flvPlayer = flvjs.createPlayer({
                        type: 'flv',
                        url: video.src
                    });
                    flvPlayer.attachMediaElement(video);
                    flvPlayer.load();
                }
                if (this.type === 'dash' && dashjs) {
                    dashjs.MediaPlayer().create().initialize(video, video.src, false);
                }
            }
        },
        {
            key: 'initVideo',
            value: function initVideo(video, type) {
                var _this2 = this;
                this.initMSE(video, type);
                this.on('durationchange', function () {
                    if (video.duration !== 1) {
                        _this2.container.getElementsByClassName('dplayer-dtime')[0].innerHTML = _utils2.default.secondToTime(video.duration);
                    }
                });
                this.on('progress', function () {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this2.updateBar('loaded', percentage, 'width');
                });
                this.on('error', function () {
                    _this2.tran && _this2.notice && _this2.notice(_this2.tran('This video fails to load'), -1);
                });
                this.ended = false;
                this.on('ended', function () {
                    _this2.updateBar('played', 1, 'width');
                    if (!_this2.loop) {
                        _this2.ended = true;
                        _this2.pause();
                    } else {
                        _this2.seek(0);
                        video.play();
                    }
                    if (_this2.danmaku) {
                        _this2.danmaku.danIndex = 0;
                    }
                });
                this.on('play', function () {
                    if (_this2.paused) {
                        _this2.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this2.paused) {
                        _this2.pause();
                    }
                });
                var _loop2 = function _loop2(i) {
                    video.addEventListener(_this2.events.videoEvents[i], function () {
                        _this2.events.trigger(_this2.events.videoEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop2(i);
                }
                this.volume(this.user.get('volume'), true, true);
                if (this.options.subtitle) {
                    this.subtitle = new _subtitle2.default(this.container.getElementsByClassName('dplayer-subtitle')[0], this.video, this.options.subtitle, this.events);
                    if (!this.user.get('subtitle')) {
                        this.subtitle.hide();
                    }
                }
            }
        },
        {
            key: 'switchQuality',
            value: function switchQuality(index) {
                var _this3 = this;
                if (this.qualityIndex === index || this.switchingQuality) {
                    return;
                } else {
                    this.qualityIndex = index;
                }
                this.switchingQuality = true;
                this.quality = this.options.video.quality[index];
                this.container.getElementsByClassName('dplayer-quality-icon')[0].innerHTML = this.quality.name;
                var paused = this.video.paused;
                this.video.pause();
                var videoHTML = _html2.default.video(false, null, this.options.screenshot, 'auto', this.quality.url, this.options.subtitle);
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                var parent = this.container.getElementsByClassName('dplayer-video-wrap')[0];
                parent.insertBefore(videoEle, parent.getElementsByTagName('div')[0]);
                this.prevVideo = this.video;
                this.video = videoEle;
                this.initVideo(this.video, this.quality.type || this.options.video.type);
                this.seek(this.prevVideo.currentTime);
                this.notice(this.tran('Switching to') + ' ' + this.quality.name + ' ' + this.tran('quality'), -1);
                this.events.trigger('quality_start', this.quality);
                this.on('canplay', function () {
                    if (_this3.prevVideo) {
                        if (_this3.video.currentTime !== _this3.prevVideo.currentTime) {
                            _this3.seek(_this3.prevVideo.currentTime);
                            return;
                        }
                        parent.removeChild(_this3.prevVideo);
                        _this3.video.classList.add('dplayer-video-current');
                        if (!paused) {
                            _this3.video.play();
                        }
                        _this3.prevVideo = null;
                        _this3.notice(_this3.tran('Switched to') + ' ' + _this3.quality.name + ' ' + _this3.tran('quality'));
                        _this3.switchingQuality = false;
                        _this3.events.trigger('quality_end');
                    }
                });
            }
        },
        {
            key: 'mouseHandler',
            value: function mouseHandler(pbar, timeTips) {
                var _this4 = this;
                var cumulativeOffset = function cumulativeOffset(element) {
                    var top = 0, left = 0;
                    do {
                        top += element.offsetTop || 0;
                        left += element.offsetLeft || 0;
                        element = element.offsetParent;
                    } while (element);
                    return {
                        top: top,
                        left: left
                    };
                };
                return function (e) {
                    if (!_this4.video.duration) {
                        return;
                    }
                    var clientX = e.clientX;
                    var px = cumulativeOffset(pbar).left;
                    var tx = clientX - px;
                    if (tx < 0 || tx > pbar.offsetWidth) {
                        return;
                    }
                    var time = _this4.video.duration * (tx / pbar.offsetWidth);
                    timeTips.style.left = tx - 20 + 'px';
                    switch (e.type) {
                    case 'mouseenter':
                        _this4.thumbnails && _this4.thumbnails.show();
                        break;
                    case 'mousemove':
                        _this4.thumbnails && _this4.thumbnails.move(tx);
                        timeTips.innerText = _utils2.default.secondToTime(time);
                        _this4.timeTipsDisplay(true, timeTips);
                        break;
                    case 'mouseleave':
                        _this4.thumbnails && _this4.thumbnails.hide();
                        _this4.timeTipsDisplay(false, timeTips);
                        break;
                    }
                };
            }
        },
        {
            key: 'timeTipsDisplay',
            value: function timeTipsDisplay(show, timeTips) {
                if (show) {
                    if (this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.remove('hidden');
                    this.isTimeTipsShow = true;
                } else {
                    if (!this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.add('hidden');
                    this.isTimeTipsShow = false;
                }
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this5 = this;
                this.thumbnails = new _thumbnails2.default(this.container.getElementsByClassName('dplayer-bar-preview')[0], this.container.getElementsByClassName('dplayer-bar-wrap')[0].offsetWidth, this.options.video.thumbnails, this.events);
                this.on('loadedmetadata', function () {
                    _this5.thumbnails.resize(160, 90);
                });
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var _this6 = this;
                var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
                var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.8;
                var noticeEle = this.container.getElementsByClassName('dplayer-notice')[0];
                noticeEle.innerHTML = text;
                noticeEle.style.opacity = opacity;
                if (this.noticeTime) {
                    clearTimeout(this.noticeTime);
                }
                this.events.trigger('notice_show', text);
                this.noticeTime = setTimeout(function () {
                    noticeEle.style.opacity = 0;
                    _this6.events.trigger('notice_hide');
                }, time);
            }
        },
        {
            key: 'resize',
            value: function resize() {
                if (this.danmaku) {
                    this.danmaku.resize();
                }
                this.events.trigger('resize');
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                clearTimeout(this.hideTime);
                this.video.src = '';
                this.container.innerHTML = '';
                this.events.trigger('destroy');
                for (var key in this) {
                    if (this.hasOwnProperty(key) && key !== 'paused') {
                        delete this[key];
                    }
                }
            }
        }
    ]);
    return DPlayer;
}();
module.exports = DPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/DPlayer.js
// module id = 2
// module chunks = 0